import moment, { Moment } from 'moment';
import {WrappedFormUtils} from "antd/lib/form/Form";

/**
 * Ensures that the expiration date is after the completion date.
 * @param form Component form instance
 */
export function getExpirationDateValidator(form: WrappedFormUtils) {
    return (rule: any, value: Moment, callback: (msg?: string) => void) => {
        const completionDate = form.getFieldValue('completionDate');
        if (value && completionDate && !value.isAfter(completionDate, 'day')) {
            callback('Expiration date must be after completion date');
        } else {
            callback();
        }
    }
}

/**
 * Ensures that the completion date is before the expiration date and not in the future from today.
 * @param form Component form instance
 */
export function getCompletionDateValidator(form: WrappedFormUtils) {
    return (rule: any, value: Moment, callback: (msg?: string) => void) => {
        const expirationDate = form.getFieldValue('expirationDate');
        if (value) {
            if (expirationDate && !value.isBefore(expirationDate, 'day')) {
                callback('Completion date must be before expiration date');
                return;
            }
            if (!value.isSameOrBefore(moment(), 'day')) {
                callback('Completion date cannot be in the future');
                return;
            }
        }
        callback();
    }
}
